





















import { IEntityMapping } from "@/typings/import";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Passenger from "@/components/Passenger/models/Passenger";
import MappingPropertyInput from "@/components/Importer/MappingPropertyInput.vue";
import PassengerMapping from '@/components/Importer/models/passenger/PassengerMapping';

@Component({
  components: {
    MappingPropertyInput
  }
})
export default class PassengerUtilityMapper extends Vue {
  selectedUtilities: string = "";

  @Prop({ required: true }) passengerMapping: IEntityMapping<Passenger>;

  get utilities() {
    return Passenger.utilities.map(u => u);
  }

  get utilityMappings() {
    if (!this.passengerMapping || !this.passengerMapping.props) {
      return [];
    }
    const utilityMappings = this.passengerMapping.props
      .filter(p => p && p.propertyName && p.propertyName.includes(PassengerMapping.UTILITY_KEY));
    return utilityMappings;
  }

  getUtilityLabel(propertyName: string) {
    const nameParts = propertyName.split('-');
    if (nameParts.length !== 2) {
      return '';
    }
    const id = nameParts[1];
    const utility = this.utilities.find(u => u.id === parseInt(id, 10));
    if (!utility) {
      return '';
    }
    return this.$i18n.translate('utility.title.' + utility.title, utility.title);
  }
}
